import api from "./api";

const reconciliationService = {
  // ── Clerk ──────────────────────────────────────────────────────────────────
  getClerkTodaySummary: (params) => api.get("/reconciliation/clerk/today-summary", { params }),
  submitHandover: (data) => api.post("/reconciliation/clerk/submit-handover", data),
  getClerkHandovers: (params) => api.get("/reconciliation/clerk/handovers", { params }),

  // ── Accountant ─────────────────────────────────────────────────────────────
  getPendingHandovers: (params) => api.get("/reconciliation/accountant/pending-handovers", { params }),
  receiveHandover: (id, data) => api.put(`/reconciliation/accountant/receive-handover/${id}`, data),
  recordDeposit: (data) => api.post("/reconciliation/accountant/record-deposit", data),
  getDeposits: (params) => api.get("/reconciliation/deposits", { params }),

  // ── Shared Detail ──────────────────────────────────────────────────────────
  getHandoverById: (id) => api.get(`/reconciliation/handovers/${id}`),

  // ── Dashboards & Audit ─────────────────────────────────────────────────────
  getDashboardSummaryStats: (params) => api.get("/reconciliation/stats/summary", { params }),
  getSuperAdminRadar: () => api.get("/reconciliation/stats/superadmin-radar"),
  getAuditLogs: (params) => api.get("/reconciliation/audit-logs", { params }),
};

export default reconciliationService;
